import { API_HOSTNAME } from 'constants/api'

/**
 * Open-redirect guard for the `externalRedirect` login search param.
 *
 * The login page normally redirects within the SPA (the `redirect` param). The
 * OAuth Login URI bridge (apps/api `/oauth/login`) lives on a DIFFERENT
 * origin (api.* vs app.*), so it needs the browser sent back to an absolute,
 * cross-origin URL after login. Allowing an arbitrary URL there would be a
 * classic open redirect (phishing vector), so we only permit URLs whose origin
 * is exactly the API origin this web app is already configured to talk to
 * (`API_HOSTNAME()`) -- nothing else.
 *
 * Returns false for relative URLs, other hosts, and non-http(s) schemes
 * (`javascript:`/`data:` yield an opaque origin that never matches).
 */
export function isAllowedExternalRedirect(rawUrl: string | undefined): boolean {
  if (!rawUrl) return false
  try {
    const target = new URL(rawUrl)
    const allowed = new URL(API_HOSTNAME())
    return target.origin === allowed.origin
  } catch {
    return false
  }
}
